import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import { queryFnFetchErrorWrapper } from 'src/api/utils/errorHandlers';
import { useAccessToken } from 'src/hooks/useAccessToken';
import { FetchError } from 'src/types/TApiQueries';
import { NotificationSettings } from 'src/types/TNotificationSettings';
import { getNotificationSettings } from '../functions/notificationSettingsApi';
import { queryNames } from '../utils/queryNames';

export function useNotificationSettingsQuery(
  queryOptions?: UseQueryOptions<NotificationSettings, FetchError>,
) {
  const accessToken = useAccessToken();

  const fetchFn = async () => {
    const result = (await getNotificationSettings(accessToken)) as any;
    return result.data ?? result;
  };

  const queryFn = useMemo(() => queryFnFetchErrorWrapper(fetchFn), [accessToken]);

  return useQuery<NotificationSettings, FetchError>(
    [queryNames.notificationSettings],
    queryFn,
    {
      ...queryOptions,
    },
  );
}
